export default __webpack_public_path__ + "static/media/ContactUs.82d48e63.png";